module.exports = __webpack_public_path__ + "img/background.c52f1ab8.png";